
import { useState } from 'react';
import { Bookmark, BookmarkCheck } from 'lucide-react';

const SubtitleItem = ({
  subtitle,
  index,
  isActive,
  showEnglish,
  showKorean,
  isPlaying,
  currentAudioPath,
  youtubeRepeatActive,
  currentYoutubeSegment,
  audioEnabled,
  isAdminMode,
  onTimeClick,
  onToggleEnglish,
  onToggleKorean,
  onToggleAudio,
  onSubtitleClick,
  onTimeUpdate,
  setAudioEnabled,
  isBookmarked,
  onToggleBookmark
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editStartTime, setEditStartTime] = useState(subtitle.startTime);
  const [editEndTime, setEditEndTime] = useState(subtitle.endTime);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const parseTimeInput = (timeStr) => {
    const [mins, secs] = timeStr.split(':').map(Number);
    return mins * 60 + secs;
  };

  const handleEditStart = (e) => {
    e.stopPropagation();
    setIsEditing(true);
    setEditStartTime(subtitle.startTime);
    setEditEndTime(subtitle.endTime);
  };

  const handleEditCancel = (e) => {
    e.stopPropagation();
    setIsEditing(false);
    setEditStartTime(subtitle.startTime);
    setEditEndTime(subtitle.endTime);
  };

  const handleEditSave = (e) => {
    e.stopPropagation();

    // 시간 유효성 검사
    if (editStartTime >= editEndTime) {
      alert('시작 시간은 종료 시간보다 작아야 합니다.');
      return;
    }

    if (editStartTime < 0 || editEndTime < 0) {
      alert('시간은 0보다 커야 합니다.');
      return;
    }

    // 시간 업데이트 콜백 호출
    onTimeUpdate(index, editStartTime, editEndTime);
    setIsEditing(false);
  };

  const isRepeating = youtubeRepeatActive &&
    currentYoutubeSegment &&
    currentYoutubeSegment.startTime === subtitle.startTime &&
    currentYoutubeSegment.endTime === subtitle.endTime;

  return (
    <div className={`subtitle-item ${isActive ? 'active' : ''}`}>
      <div className={`subtitle-time ${isRepeating ? 'repeating' : ''}`}>
        {isEditing ? (
          <div className="time-edit-form" onClick={(e) => e.stopPropagation()}>
            <input
              type="text"
              value={formatTime(editStartTime)}
              onChange={(e) => setEditStartTime(parseTimeInput(e.target.value))}
              className="time-input"
              placeholder="0:00"
            />
            <span> - </span>
            <input
              type="text"
              value={formatTime(editEndTime)}
              onChange={(e) => setEditEndTime(parseTimeInput(e.target.value))}
              className="time-input"
              placeholder="0:00"
            />
            <div className="edit-buttons">
              <button className="save-btn" onClick={handleEditSave}>저장</button>
              <button className="cancel-btn" onClick={handleEditCancel}>취소</button>
            </div>
          </div>
        ) : (
          <div
            onClick={() => onTimeClick(subtitle.startTime, subtitle.endTime, isRepeating)}
            title={isRepeating ? "반복재생 중지" : "구간 반복재생"}
          >
            {formatTime(subtitle.startTime)} - {formatTime(subtitle.endTime)}
            {isAdminMode && (
              <button
                className="edit-time-btn"
                onClick={handleEditStart}
                title="시간 편집"
              >
                ✏️
              </button>
            )}
          </div>
        )}
      </div>

      <div className="subtitle-controls">
        <button
          className={`toggle-btn ${showEnglish ? 'active' : ''}`}
          onClick={(e) => onToggleEnglish(index, e)}
          title="영문 보이기/감추기"
        >
          EN
        </button>
        <button
          className={`toggle-btn ${showKorean ? 'active' : ''}`}
          onClick={(e) => onToggleKorean(index, e)}
          title="한글 보이기/감추기"
        >
          KO
        </button>
        {subtitle.audioPath && (
          <button
            className={`audio-btn ${isPlaying && currentAudioPath === subtitle.audioPath ? 'playing' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              if (!audioEnabled) setAudioEnabled(true);
              onToggleAudio(subtitle.audioPath);
            }}
            title={isPlaying && currentAudioPath === subtitle.audioPath ? "오디오 정지" : "오디오 재생"}
          >
            {isPlaying && currentAudioPath === subtitle.audioPath ? '⏹' : '▶'}
          </button>
        )}
        <button
          className={`bookmark-btn ${isBookmarked ? 'bookmarked' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onToggleBookmark(index);
          }}
          title={isBookmarked ? "북마크 제거" : "북마크 추가"}
        >
          {isBookmarked ? <BookmarkCheck size={16} /> : <Bookmark size={16} />}
        </button>
      </div>

      <div
        className="subtitle-text"
        onClick={() => onSubtitleClick(subtitle)}
      >
        {showEnglish && (
          <div className="english-section">
            <div className="english">{subtitle.english}</div>
            {subtitle.comment && (
              <div className="comment">{subtitle.comment}</div>
            )}
            {subtitle.words && Array.isArray(subtitle.words) && subtitle.words.length > 0 && (
              <div className="words">
                <div className="words-list">
                  {subtitle.words.map((wordObj, index) => (
                    <div key={index} className="word-item">
                      <span className="word">{wordObj.word}</span>
                      <span className="meaning">{wordObj.meaning}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
        {showKorean && (
          <div className="korean">{subtitle.korean}</div>
        )}
      </div>
    </div>
  );
};

export default SubtitleItem;